import { SUPPORTED_FILE_TYPES } from "~/CustomizableToolPage/CustomizableTool/constants";

interface ImageUpload {
  userId: string;
  sessionId: string;
  files: FileList;
}

export const uploadImage = async ({
  userId,
  sessionId,
  files,
}: ImageUpload) => {
  const file = files[0];

  if (!file || (!userId && !sessionId)) return Promise.reject();

  if (
    !SUPPORTED_FILE_TYPES.some((ft) => file.name.toLowerCase().endsWith(ft))
  ) {
    return Promise.reject(new Error("Unsupported file type"));
  }

  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("sessionId", sessionId);
  formData.append("file", file);

  return fetch("/customized-products/upload/", {
    method: "POST",
    body: formData,
  });
};
